import React, { FC } from 'react';
import Modal from 'react-modal'
import { Spinner } from 'react-activity'

interface ProgressModalProps {
    isOpen: boolean;
    title: string;
    children: any
}

const ProgressModal: FC<ProgressModalProps> = ({isOpen, title, children}) => {
    return <>
        <Modal
            isOpen={isOpen}
            ariaHideApp={false}
            overlayClassName="flex w-screen position-float-modal fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
            className="bg-white border-none m-auto shadow select-none outline-none overflow-hidden" >
            <div className={`w-full p-2 border-b flex flex-row items-center bg-sidemenu-focus text-white justify-between`}>
                <div className="flex flex-row">
                    <p className="pl-3 font-bold font text-white">{title}</p>
                </div>
            </div>
            <div className="flex flex-row" style={{minWidth:"310px"}}>
                <div className="flex px-6 flex-wrap content-center">
                    <Spinner
                        color="#727981"
                        size={32}
                        speed={1}
                        animating={true} />
                </div>
                {children}
            </div>
        </Modal>
    </>
}

export default ProgressModal;
